import { render, staticRenderFns } from "./VideoCardView.vue?vue&type=template&id=53e7ff54&"
import script from "./VideoCardView.vue?vue&type=script&lang=js&"
export * from "./VideoCardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports